import { MapPin, Loader2, RefreshCw, AlertTriangle } from "lucide-react";

export default function GpsCard({ state, onRefresh }) {
  const { status, coords, address, error } = state;
  const loading = status === "loading";
  const granted = status === "granted";
  const denied = status === "denied";
  const unsupported = status === "unsupported";
  const errored = status === "error";

  return (
    <div
      data-testid="gps-card"
      className="sa-card overflow-hidden"
    >
      <div className="flex items-start gap-4 px-5 py-5">
        <div
          className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-[14px] ${
            granted
              ? "bg-[var(--sa-blue-soft)] text-[var(--sa-blue)]"
              : denied || unsupported || errored
              ? "bg-amber-50 text-amber-600"
              : "bg-slate-100 text-slate-500"
          }`}
        >
          {loading ? (
            <Loader2 size={22} className="animate-spin" />
          ) : denied || unsupported || errored ? (
            <AlertTriangle size={22} />
          ) : (
            <MapPin size={22} />
          )}
        </div>

        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-center justify-between gap-2">
            <h3
              className="text-[14px] font-semibold text-slate-900"
              style={{ letterSpacing: "-0.01em" }}
            >
              Ma position
            </h3>
            {granted ? (
              <button
                onClick={onRefresh}
                data-testid="gps-refresh"
                className="flex items-center gap-1 rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[11px] font-medium text-slate-600 transition hover:border-slate-300 hover:bg-slate-50"
              >
                <RefreshCw size={11} />
                Actualiser
              </button>
            ) : null}
          </div>

          {loading ? (
            <p className="mt-1 text-[13px] text-slate-500" data-testid="gps-loading">
              Récupération de votre position…
            </p>
          ) : null}

          {granted ? (
            <>
              <p
                className="mt-1 text-[14px] font-medium text-slate-800 leading-snug"
                data-testid="gps-address"
              >
                {address || "Adresse non résolue (coordonnées disponibles)."}
              </p>
              {coords ? (
                <p className="mt-1 text-[11px] font-mono text-slate-400">
                  {coords.lat.toFixed(5)}, {coords.lng.toFixed(5)}
                  {coords.accuracy ? ` · ±${Math.round(coords.accuracy)} m` : ""}
                </p>
              ) : null}
            </>
          ) : null}

          {denied ? (
            <>
              <p className="mt-1 text-[13px] font-medium text-amber-700" data-testid="gps-denied">
                Géolocalisation refusée.
              </p>
              <p className="mt-1 text-[12px] text-slate-500 leading-snug">
                Votre position n'est partagée qu'au déclenchement d'un feu. Activez-la
                dans les réglages du navigateur puis réessayez.
              </p>
              <button
                onClick={onRefresh}
                data-testid="gps-retry"
                className="mt-3 w-fit rounded-full bg-[var(--sa-blue)] px-4 py-2 text-[12px] font-semibold text-white transition hover:bg-[var(--sa-blue-dark)]"
              >
                Autoriser la géolocalisation
              </button>
            </>
          ) : null}

          {(unsupported || errored) && !denied ? (
            <>
              <p className="mt-1 text-[13px] font-medium text-amber-700">
                {error || "Position indisponible."}
              </p>
              <p className="mt-1 text-[12px] text-slate-500">
                Vous pouvez toujours saisir l'adresse manuellement ci-dessous.
              </p>
              <button
                onClick={onRefresh}
                data-testid="gps-retry"
                className="mt-3 w-fit rounded-full border border-slate-200 bg-white px-4 py-2 text-[12px] font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                Réessayer
              </button>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
